import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    home: "Home",
    followup: "Track a ticket",
    privateSector: "Private Sector",
    noaccounts: "No Accounts",
    about: "About Us",
    readyToReport: "Ready to Report an Incident?",
    reportIncidentNow: "Report Incident Now",
    trackExistingReport: "Track Existing Incident",
    saerch: "Search",
    contactUs: "Contact Us",
    emptysearchResults: "No Results Found.",
    reportIncident: "Report Incident",
    addStructure: "Add Structure",
    language: "EN",
    officialAccounts: "Official Accounts Directory",
    nationalAgency: "NATIONAL AGENCY FOR INFORMATION AND COMMUNICATION TECHNOLOGIES",
    directory: "DIRECTORY OF THE OFFICIAL ACCOUNTS OF PUBLIC AND PRIVATE STRUCTURES",
    head: "Head of Structure",
    otherspersonnels: "Key Personnels",
    regionals: "Regional Delegations",
    more: "read more",
    auth: "Cyber Incident Reporting and Tracking Platform",
    fillFormBelow: "Fill out the form below to report any social media impersonated accounts.",
    name: "Full Names",
    enterName: "Please enter your full names here",
    phone: "Phone Number",
    enterPhone: "Please enter your phone number",
    email: "Email",
    enterEmail: "Please enter a valid email account",
    description: "Description",
    evidences: "Evidences",
    maxFiles: "Evidence should not exceed 5",
    browseFiles: "Browse Files",
    dragDropFiles: "Drag and Drop Files",
    addMoreFiles: "Add More Evidence",
    submit: "Submit",
    submitting: "Submitting",
    construct: "In Maintenance",
    constructMessage: "We're currently working on this section. Please check back soon!",
    messageContact: "Send Us a Message",
    umsg: "Your Message",
    location: "Location",
    actuallocation: "Chinese Embassy Street (Bastos)",
    townnation: "Yaounde",
    follow: "Follow Us on",
    instructform: "Fill out the form or reach out through our other channels",
    contactinfo: "Contact Information",
    emergency: "Emergency",
    intouch: "Get In Touch with Us",
    intouchinfo: "We're here to help and answer any questions you might have",
    footerbanner: "Get along with us on social networks:",
    apptitle: "CHECK-APP",
    appdes: "CHECK-APP is a solution that intends to reduce the risk of cyber crime, especially on social media by regrouping the official social media accounts of public and private renowned structures",
    otherRrc: "OTHER RESOURCES",
    usefullinks: "USEFUL LINKS",
    contacts: "CONTACTS",
    success: "Your Message has been successful submitted. Our Staff will reach out to you soon!",
    nomissionsTtile: "Coming Soon",
    nomissiondescription: "We are currently developing our mission portfolio with great care and precision.",
    nomissionnote: "Please check back soon for updates.",
    noMissiondes: "No description yet for this mission",
    missions: "Missions",
    popularMinistries: "Popular Ministries",
    noPrivateSectorsAvailable: "No private sectors available at this time",
    fetchError: "Could not load data. Please try again later.",
    searchEmbassies: "Search for Cameroon Embassies",
    loading: "loading",
    embassies: "Diplomatic Missions",
    noContactAvailable: "No Account",
    noResultsTitle: "No Title for this Result",
    noDescriptionAvailable: "More details coming—check back later!",
    noDataAvailable: "No Data Available",
    noPhoneNumber: "No Phone Numbers Available",
    noLocation: "No Location Details",
    Main: "Main Contact",
    getDirections: "Get Google Map Direction",
    noInformationAvailable: "Not available for Now",
    bossContactSection: "Connect and Follow",
    noLocationAvailable: "No Location Details Available",
    readMore: "read more",
    clearHistory: "Clear History",
    noRegionalsTitle: "No Regional Delegations Available",
    noRegionalsDescription: "Regional delegation information will be added soon.",
    searchPlaceholderShort: "Enter any key word",
    previous: "Previous",
    next: "Next",
    embassiesAndConsulates: "Embassies and Consulates",
    servicesOffered: "Services Offered",
    "About CIRT": "About CIRT",

    hero: {
      title1: "Cybersecurity Incident",
      title2: "Reporting Platform",
      subtitle: "Official portal for secure incident reporting, tracking, and resolution management.",
      cardCyberTitle: "Report Cyber Incident",
      cardCyberDesc: "Report System Compromise, Spams, phishing and other cyber threats",
      cardCyberBtn: "Report Now",
      cardComplaintTitle: "File a Complaint",
      cardComplaintDesc: "Submit an official ANTIC judicial complaint form",
      cardComplaintBtn: "File Now",
      cardTrackTitle: "Track Status",
      cardTrackDesc: "Monitor incident resolution progress",
      cardTrackBtn: "Track Now",
      cardIncidentsTitle: "Incidents Handled",
      cardIncidentsDesc: "Learn what type of incidents we manage",
      cardIncidentsBtn: "View Types",
      titleLine1: "Cybersecurity Incident",
      titleLine2: "Reporting Platform",
      cards: {
        cyberIncident: { title: "Report Cyber Incident", description: "Report identity theft, scamming, phishing, and other cybersecurity incidents", button: "Report Now" },
        complaint: { title: "Judicial Complaint", description: "Fill and submit an ANTIC complaint form for cybercrime offences", button: "File Complaint" },
        trackStatus: { title: "Track Status", description: "Monitor incident resolution progress", button: "Track Now" },
        howToReport: { title: "How to Report", description: "Learn the reporting and follow-up process", button: "View Guide" }
      }
    },

    contactInput: {
      title: 'Identity Verification',
      subtitle: "We'll send you a secure verification code",
      emailLabel: 'Email Address',
      emailBadge: 'Email',
      emailPlaceholder: "you{'@'}example.com",
      emailHint: "Enter the email address where you'll receive the verification code",
      whatsappDownUseEmail: "WhatsApp is temporarily unavailable. Please enter your email address to receive your verification code by email instead.",
      phoneLabel: 'Phone Number',
      phonePlaceholder: '6XX XXX XXX',
      phoneHint: 'Enter your phone number to receive the verification code via WhatsApp',
      backBtn: 'Back',
      sendBtn: 'Send Code',
      sendingBtn: 'Sending Code...'
    },

    reportType: {
      title: "Report an",
      titleHighlight: "Incident",
      subtitle: "Choose the type of report that best matches your situation.",
      chooseType: "Select Report Type",
      chooseTypeDesc: "Each form is designed for a specific category of incident.",
      cyberTitle: "Report Cyber Security Incident",
      cyberDesc: "For System Compromise, Spams, phishing, and other cyber threats.",
      complaintTitle: "ANTIC Complaint Form",
      complaintDesc: "Official judicial complaint form for incidents requiring legal action and formal investigation by ANTIC.",
      tagIdentityTheft: "System Compromise",
      tagScamming: "Spam / Fraud",
      tagPhishing: "Phishing",
      tagJudicial: "Judicial",
      tagOfficial: "Official Form",
      privacy: "Privacy",
      terms: "Terms",
      help: "Help"
    },

    reportSelection: {
      title: "What would you like to report?",
      subtitle: "Choose the type of report that best fits your situation. Both forms are secure and confidential.",
      backToHome: "Back to Home",
      cyberIncident: {
        title: "Report a Cyber Security Incident",
        description: "Use this form to report cybersecurity incidents such as identity theft, scamming, phishing, data breaches, or any online fraud. A plaintiff ID card and evidence are required.",
        cta: "Start Cyber Incident Report",
        tags: { identityTheft: "Identity Theft", scamming: "Scamming", phishing: "Phishing", hacking: "Hacking" }
      },
      anticComplaint: {
        title: "Fill & Submit ANTIC Complaint Form",
        description: "Complete the official ANTIC judicial complaint form for cybercrimes including account hijacking, impersonation, web defacement, cyber harassment, and malware infections.",
        cta: "Start Complaint Form",
        tags: { webDefacement: "Web Defacement", accountHijack: "Account Hijacking", malware: "Malware" }
      }
    },

    cyber: {
      searchCountry: 'Search country...',
      noResults: 'No results found',
      formTitle: "Cybersecurity",
      formTitleHighlight: "Incident Report",
      formSubtitle: "Declare your cybersecurity incident securely. All information is encrypted and confidential.",
      stepType: "Type", stepInfo: "Information", stepDetails: "Details", stepEvidence: "Evidence", stepDone: "Done",
      step0Title: "Type of Incident", step0Desc: "Select one or more incident types that apply to your situation.",
      step1Title: "Contact Information", step1Desc: "Provide your personal identification details. This is required for processing your report.",
      step2Title: "Incident Details", step2Desc: "Describe the incident with as much detail as possible.",
      step3Title: "Supporting Evidence", step3Desc: "Upload screenshots, documents, or any files that support your report.",
      typeIdentityTheft: "Identity Theft", typeIdentityTheftDesc: "Someone is using your identity without authorization",
      typeScamming: "Scamming / Fraud", typeScammingDesc: "Financial fraud, fake offers, money transfer scams",
      typePhishing: "Phishing", typePhishingDesc: "Deceptive emails or websites to steal credentials",
      typeAccountHijack: "Account Hijacking", typeAccountHijackDesc: "Unauthorized access to your social media or email account",
      typeCyberHarassment: "Cyber Harassment", typeCyberHarassmentDesc: "Online threats, bullying, or intimidation",
      typeMalware: "Malware / Ransomware", typeMalwareDesc: "Malicious software infection on your device",
      typeDataBreach: "Data Breach", typeDataBreachDesc: "Unauthorized access to personal or organizational data",
      typeOther: "Other", typeOtherDesc: "Any other cybersecurity incident not listed above",
      specifyOther: "Please specify the type of incident...",
      fullName: "Full Name", fullNamePh: "Enter your full name",
      email: "Email Address", emailPh: "your.email{'@'}example.com",
      phone: "Phone Number", city: "City / Town", cityPh: "e.g. Yaoundé",
      address: "Residential Address", addressPh: "Enter your address",
      idSection: "Identity Document", idType: "Document Type", selectIdType: "-- Select document type --",
      cni: "National ID Card (CNI)", passport: "Passport", driverLicense: "Driver's License", residencePermit: "Residence Permit",
      idNumber: "Document Number", idNumberPh: "Enter document number",
      idUpload: "Upload ID Document", idUploadHint: "Click or drag your ID document here",
      remove: "Remove", incidentDate: "Date of Incident", incidentTime: "Time (approximate)",
      platform: "Platform / Service Affected", selectPlatform: "-- Select platform --",
      emailService: "Email Service", website: "Website", banking: "Banking / Finance", otherPlatform: "Other",
      suspectInfo: "Suspect Information (if known)", suspectInfoPh: "Phone number, username, account, URL...",
      financialLoss: "Estimated Financial Loss", financialLossPh: "Amount (if applicable)",
      description: "Detailed Description of the Incident",
      descriptionPh: "Describe what happened, when, how you discovered it, actions taken so far...",
      dragDrop: "Click or drag files here to upload",
      evidenceFormats: "Images, PDFs, documents, videos - Max 50 MB total, 15 files",
      continue: "Continue", back: "Back", submitReport: "Submit Report", submitting: "Submitting...",
      successTitle: "Report Submitted Successfully!", successDesc: "Your cybersecurity incident report has been received. Our team will review it and contact you shortly.",
      referenceLabel: "Reference Number", referenceHint: "Save this number to track your report",
      newReport: "Submit Another Report", backHome: "Back to Home", securedBy: "Secured with reCAPTCHA",
      errSelectType: "Please select at least one incident type.", errSpecifyOther: "Please specify the incident type.",
      errRequired: "This field is required.", errValidEmail: "Please enter a valid email address.",
      errIdUpload: "Please upload your ID document.", errDescMin: "Description must be at least 20 characters.",
      errFileSize: "File must be under 10 MB.", errFileType: "Invalid file type. Only JPG, PNG, and PDF are accepted.",
      errEvidenceSize: "Total evidence size cannot exceed 50 MB.", errEvidenceCount: "Maximum 15 evidence files allowed.",
      submitSuccess: "Report submitted successfully!", submitError: "An error occurred. Please try again."
    },

    submissionProgress: {
      title: 'Processing Submission',
      message: 'Please wait while we process your complaint...',
      complete: '{percent}% complete'
    },

    privacyBanner: {
      title: 'Privacy Notice',
      intro: 'We protect your data in compliance with',
      law: "Cameroon's Data Protection Law (2024)",
      introSuffix: 'and follow industry best practices for cybersecurity.',
      keyProtections: 'Key protections:',
      bullet1: 'Compliance with national data protection regulations',
      bullet2: 'Industry-standard encryption and security measures',
      bullet3: 'Data used only for incident reporting and response',
      acknowledgement: 'By continuing, you acknowledge our privacy practices.',
      acceptBtn: 'I Understand'
    },

    privacy: {
      title: "Privacy Notice",
      body: "We protect your data in compliance with",
      law: "Cameroon's Data Protection Law (2024)",
      bodyEnd: "and follow industry best practices for cybersecurity.",
      keyProtections: "Key protections:",
      protection1: "Compliance with national data protection regulations",
      protection2: "Industry-standard encryption and security measures",
      protection3: "Data used only for incident reporting and response",
      consent: "By continuing, you acknowledge our privacy practices.",
      accept: "I Understand"
    },

    objectives: {
      title: 'Features and',
      titleHighlight: 'Capabilities',
      description: 'Comprehensive cybersecurity incident management platform built on industry best practices and proven frameworks',
      card1: {
        title: 'Efficient Reporting', badge: 'Core',
        description: 'Streamline incident reporting processes with intuitive workflows, automated documentation, and standardized compliant forms with industry frameworks. You can now report incidents quickly and accurately from anywhere, at any time.',
        tag1: 'Auto-classification', tag2: 'Fast and Reliable', tag3: 'No need to displace yourself'
      },
      card2: { title: 'Real-Time Updates', description: 'Track the status of your complaints and incidents in real time. Find out immediately when there are updates, changes, or resolutions.', badge: 'Active Monitoring' },
      card3: { title: 'Advanced Analytics', description: 'Track your complaints and incidents with comprehensive dashboards and post significant actions if applicable. You can complete and update your incidents and complaints from the dashboard.' },
      card4: { title: 'What type of Incidents are handled?', description: 'There is a wide range of cybersecurity and security precursors incidents that our platform is designed to handle, including but not limited to: Phone/Tablet Theft or Loss, Hacked Social Media Accounts, Email Account Compromise, Scamming, Identity Theft Attempts, Web Defacement, Publication of Malicious Content, Cyber Harassment, Malware Infection, Supply Chain Attacks.', badge: '256-bit AES Encryption' },
      card5: { title: 'Privacy and Confidentiality', description: 'Our platform is built with a strong emphasis on privacy and confidentiality. Based on best practices, we ensure that all user data and incident details are securely stored and transmitted using advanced encryption protocols. Cameroon Incident Response Team (CIRT) adheres to strict data protection policies to safeguard sensitive information, following the law on personal data protection in Cameroon.' },
      card6: { title: 'Global Accessibility', description: 'Access the platform securely from any location worldwide with robust multi-language support and 24/7 availability.', bullet1: 'This platform is primarily designed to respond to incidents in Cameroon', bullet2: 'Should an incident escalate beyond our territory of influence, coordinated efforts with international organs are triggered.', bullet3: 'Support for major languages including English and French' },
      titleLine1: "Features and", titleLine2: "Capabilities",
      subtitle: "Comprehensive cybersecurity incident management platform built on industry best practices and proven frameworks",
      cards: {
        reporting: { title: "Efficient Reporting", badge: "Core", description: "Streamline incident reporting processes with intuitive workflows, automated documentation, and standardized compliant forms with industry frameworks. You can now report incidents quickly and accurately from anywhere, at any time.", tag1: "Auto-classification", tag2: "Fast and Reliable", tag3: "No need to displace yourself" },
        realtime: { title: "Real-Time Updates", description: "Track the status of your complaints and incidents in real time. Find out immediately when there are updates, changes, or resolutions.", badge: "Active Monitoring" },
        analytics: { title: "Advanced Analytics", description: "Track your complaints and incidents with comprehensive dashboards and post significant actions if applicable. You can complete and update your incidents and complaints from the dashboard." },
        incidentTypes: { title: "What type of Incidents are handled?", description: "There is a wide range of cybersecurity and security precursors incidents that our platform is designed to handle, including but not limited to: Phone/Tablet Theft or Loss, Hacked Social Media Accounts, Email Account Compromise, Scamming, Identity Theft Attempts, Web Defacement, Publication of Malicious Content, Cyber Harassment, Malware Infection, Supply Chain Attacks." },
        privacySecurity: { title: "Privacy and Confidentiality", description: "Our platform is built with a strong emphasis on privacy and confidentiality. Based on best practices, we ensure that all user data and incident details are securely stored and transmitted using advanced encryption protocols. Cameroon Incident Response Team (CIRT) adheres to strict data protection policies to safeguard sensitive information, following the law on personal data protection in Cameroon." },
        globalAccess: { title: "Global Accessibility", description: "Access the platform securely from any location worldwide with robust multi-language support and 24/7 availability.", point1: "This platform is primarily designed to respond to incidents in Cameroon", point2: "Should an incident escalate beyond our territory of influence, coordinated efforts with international organs are triggered.", point3: "Support for major languages including English and French" }
      }
    },

    cyberForm: {
      otherNatureLabel: 'Please specify the nature of the incident',
      otherNaturePlaceholder: 'e.g. Insider threat, SIM swapping...',
      headerText: "You can use this form to report cybersecurity incidents that occurred within your organization.",
      contactSection: "Contact", organisation: "Organisation", fullName: "Full Name",
      telephone: "Telephone", telephonePh: "Enter your phone number", email: "Email",
      incidentSection: "Incident", incidentSubject: "Incident Subject", incidentNature: "Nature of the Incident",
      select: "Select", incidentDate: "Incident Date", affectedAssets: "Affected Assets",
      detailedDescription: "Detailed Description of the Incident", send: "Submit", sending: "Submitting...",
      sidebarTitle: "How to contact CIRT-CM in case of cyber incidents?",
      viaEmail: "Via Email", viaPhone: "Via Telephone", website: "Website",
      natureIdentityTheft: "Identity Theft", natureScamming: "Scamming / Fraud", naturePhishing: "Phishing",
      natureAccountHijack: "Account Hijacking", natureCyberHarassment: "Cyber Harassment",
      natureMalware: "Malware / Ransomware", natureDataBreach: "Data Breach",
      natureWebDefacement: "Web Defacement", natureDos: "Denial of Service (DoS/DDoS)",
      natureRansomware: "Ransomware", natureOther: "Other",
      errRequired: "This field is required.", errValidEmail: "Please enter a valid email address.",
      errDescMin: "Description must be at least 10 characters.",
      submitSuccess: "Report submitted successfully!", submitError: "An error occurred. Please try again.",
      successTitle: "Report Submitted Successfully!",
      successDesc: "Your cybersecurity incident report has been received. Our team will review it and contact you shortly.",
      referenceLabel: "Reference Number", referenceHint: "Save this number to track your report",
      newReport: "Submit Another Report", backHome: "Back to Home", securedBy: "Secured with reCAPTCHA",
      sidebarSubtitle: "You can reach out to us through the following channels for any cybersecurity incident:",
      pageTitle: "Cybersecurity Incident Report",
      pageSubtitle: "Use this form to report cybersecurity incidents. All fields marked with * are required.",
      sections: { contact: "Contact", incident: "Incident" },
      fields: {
        organisation: "Organisation", fullName: "Full Name", phone: "Phone", email: "Email",
        idCard: "Plaintiff ID Card", idCardHint: "Upload front and back of your national ID card or passport (JPG, PNG or PDF, max 10MB each)",
        idFront: "Front side", idBack: "Back side", clickOrDrag: "Click or drag file",
        incidentSubject: "Subject of the Incident", incidentNature: "Nature of the Incident",
        incidentDate: "Date of the Incident", affectedAssets: "Affected Assets",
        detailedDescription: "Detailed Description of the Incident", evidence: "Evidence",
        evidenceHint: "Upload screenshots, documents, or any proof of the incident (max 10 files, 25MB total)",
        dragEvidence: "Click or drag files to upload evidence", maxFileSize: "JPG, PNG, PDF, DOC, ZIP — Max 25MB total"
      },
      placeholders: { phone: "Phone number", select: "Select" },
      natures: {
        identityTheft: "Identity Theft", scamming: "Scamming / Online Fraud", phishing: "Phishing",
        ransomware: "Ransomware", dataBreach: "Data Breach", ddos: "DDoS Attack",
        malware: "Malware Infection", socialEngineering: "Social Engineering", webDefacement: "Web Defacement",
        unauthorizedAccess: "Unauthorized Access", accountHijacking: "Account Hijacking",
        cyberHarassment: "Cyber Harassment", other: "Other"
      },
      validation: {
        required: "This field is required", invalidEmail: "Please enter a valid email address",
        idRequired: "Front side of ID card is required", fileTooLarge: "File size must be under 10 MB",
        invalidFileType: "Invalid file type. Accepted: JPG, PNG, PDF",
        totalSizeExceeded: "Total file size exceeds 25 MB", maxFilesExceeded: "Maximum 10 files allowed"
      },
      buttons: { back: "Back", submit: "Submit Report", submitting: "Submitting..." },
      recaptchaNotice: "This form is protected by reCAPTCHA. By submitting, you agree to our privacy policy.",
      sidebar: { title: "ANTIC - CIRT", emailLabel: "Via Email", phoneLabel: "Via Phone", faxLabel: "Fax", note: "For urgent incidents, please contact us directly by phone. Our team is available 24/7 for critical cybersecurity threats." },
      success: { title: "Report Submitted Successfully!", message: "Your cybersecurity incident report has been received. Our team will review it and contact you shortly.", reference: "Reference ID", newReport: "Submit Another Report" },
      errors: { server: "Server error occurred. Please try again later.", network: "Network error. Please check your internet connection.", generic: "An error occurred. Please try again." },
      footer: { copyright: "Cyber Incident Response Team", privacy: "Privacy", terms: "Terms", help: "Help" },
      errRateLimit: "Too many submissions. Please wait and try again."
    },

    incidentForm: {
      copyright: "Privacy Notice",
      title: "Incident", titleHighlight: "Report",
      subtitle: "Welcome to Cameroon Incident Reporting Portal.",
      chooseVerification: "Choose your verification method",
      phoneVerification: "Phone Verification", phoneVerificationDesc: "Receive OTP via WhatsApp Only",
      emailVerification: "Email Verification", emailVerificationDesc: "Receive OTP via email",
      privacy: "Privacy", terms: "Terms", help: "Help",
      welcome: "Welcome to Cameroon Incident Reporting Portal.",
      steps: { verify: "Verify", personal: "Personal", documents: "Documents", incident: "Incident", evidence: "Evidence", preview: "Preview", complete: "Complete" },
      crimes: { defacement: "Web Defacement", hijacking: "Account Hijacking", itheft: "Identity Theft", cyberH: "Cyber Harassment", scamming: "Scamming / Online Fraud", malware: "Malware Infection", malicious: "Publication of malicious content", Ptheft: "Theft of Phone", blackmail: "Cyber Blackmail", other: "Others" },
      authSelection: {
        title: "Choose your verification method",
        phone: { title: "Phone Verification", description: "Receive OTP via WhatsApp Only" },
        email: { title: "Email Verification", description: "Receive OTP via email" }
      },
      footer: { copyright: "ANTIC CIRT - Cyber Incident Response Team", privacy: "Privacy", terms: "Terms", help: "Help" }
    },

    otpVerification: {
      title: 'Verify Your Identity',
      subtitleEmail: 'Enter the 6-digit verification code sent to your email {contact}',
      subtitlePhone: 'Enter the 6-digit verification code sent to your phone {contact}',
      codeExpires: 'Code expires in {time}', codeLabel: 'Verification Code',
      digitAria: 'Digit {index} of verification code', resendIn: 'Resend code in {time}',
      resendBtn: "Didn't receive code? Resend", resendingBtn: 'Resending...',
      backBtn: 'Back', verifyBtn: 'Verify & Continue', verifyingBtn: 'Verifying...'
    },

    successPage: {
      title: 'Report Submitted Successfully!',
      subtitle: 'Thank you for reporting the incident',
      description: 'Your report has been securely received and assigned a reference number. Our cybersecurity team will review your submission and contact you if additional information is needed.',
      downloadTitle: 'Download Your Complaint', downloadHint: 'Keep a copy of your complaint for your records',
      downloadBtn: 'Download Complaint PDF', downloadingBtn: 'Downloading...',
      nextStepsTitle: 'Next Steps',
      nextStep1: "You'll receive a confirmation email and/or WhatsApp message with your report reference number",
      nextStep2: 'Our team typically responds within 24-48 hours for urgent incidents',
      nextStep3: 'Keep your reference number for future correspondence and progress tracking',
      homeBtn: 'Return to Homepage', resetBtn: 'Report Another Incident'
    },

    progressBar: { step: 'Step {current} of {total}', complete: '{percent}% Complete' },

    personalInfo: {
      title: 'Personal Information', subtitle: 'Please fill in your personal information below',
      nameLabel: 'Full Name', namePlaceholder: 'John Doe',
      emailLabel: 'Email Address', emailPlaceholder: "john{'@'}example.com",
      phoneLabel: 'Phone Number', phonePlaceholder: '6XX XXX XXX',
      phoneLockedNote: 'This is the verified number that received your code and cannot be changed.',
      ownerPhoneLabel: "Case owner's phone (optional)",
      ownerPhonePlaceholder: '+237 6XX XXX XXX',
      ownerPhoneHint: 'If you are reporting on behalf of someone else, enter the victim’s phone number here.',
      professionLabel: 'Profession', professionPlaceholder: 'Software Engineer',
      docTypeLabel: 'Document Type', docTypeSelect: 'Select document type',
      docTypeNationalId: 'National ID Card', docTypePassport: 'Passport', docTypeResidence: 'Residence Permit',
      idNumberLabel: 'Number', idNumberDocument: 'Document',
      idPlaceholderNationalId: 'Enter your national ID number', idPlaceholderPassport: 'Enter your passport number',
      idPlaceholderResidence: 'Enter your residence permit number', idPlaceholderDefault: 'Enter your document number',
      backBtn: 'Back', nextBtn: 'Next', savingBtn: 'Saving...',
      errors: {
        nameRequired: 'Full name is required', nameMin: 'Name must be at least 2 characters',
        emailInvalid: 'Please enter a valid email address', phoneRequired: 'Phone number is required',
        phoneInvalid: 'Please enter a valid phone number', docTypeRequired: 'Please select a document type',
        idNumberRequired: 'Document number is required'
      }
    },

    evidenceUpload: {
      title: 'Evidence Upload & Review',
      subtitle: 'Upload supporting documents and review your complaint before submission',
      sectionTitle: 'Upload Evidence Files (Optional)',
      dropzone: 'Drag & drop files here or', chooseFiles: 'Choose Files',
      fileHint: 'Max 10 files, 25MB total • Images, PDFs, Documents',
      filesSelected: '{count} file(s) selected', clearAll: 'Clear all',
      backBtn: 'Back', previewBtn: 'Preview Complaint PDF', generatingBtn: 'Generating PDF...',
      cancelConfirm: 'Are you sure you want to cancel? All unsaved changes will be lost.',
      pdfReady: '✅ PDF ready!', downloadStarted: '✅ PDF download started!',
      modal: {
        title: 'Complaint Preview', submittingTitle: 'Submitting Complaint...',
        submittingMessage: 'Please wait while we process your submission.',
        step1: 'Confirming PDF', step2: 'Uploading Evidence', step3: 'Finalizing',
        loadingDoc: 'Loading document...', errorTitle: 'Unable to load preview',
        downloadInstead: 'Download PDF instead', downloadingBtn: 'Downloading...',
        pdfReadyTitle: 'PDF Ready!', pdfReadyMessage: 'Your complaint PDF has been generated successfully.',
        summaryTitle: 'Report Summary:', summaryName: 'Name:', summaryType: 'Type:',
        summaryDate: 'Date:', summaryRef: 'Reference:',
        viewPdfBtn: 'View PDF', downloadPdfBtn: 'Download PDF',
        docGeneratedTitle: 'Document Generated!', docGeneratedMessage: 'Your complaint is ready for submission.',
        cancelBtn: 'Cancel', confirmBtn: 'Confirm & Submit', submittingBtn: 'Submitting...'
      },
      errors: {
        maxFiles: 'Maximum {max} files allowed', totalSize: 'Total file size exceeds 25 MB',
        sessionNotFound: 'Session not found. Please complete the previous steps first.',
        generateFailed: 'Failed to generate PDF.', missingIncidentId: 'Server error: Missing incident identifier',
        previewUnavailable: 'PDF generated but preview unavailable. You can still submit.',
        previewFailed: 'Failed to load PDF preview. You can still submit.',
        error404: 'PDF generation endpoint not found. Please contact support.',
        error500: 'Server error during PDF generation. Please try again.',
        timeout: 'PDF generation timed out. Please try again.',
        network: 'Network connection error. Please check your internet.',
        invalidPdf: 'PDF file is too small or invalid', missingIdOrToken: 'Missing incident ID or access token',
        iframeError: 'PDF preview failed to load. You can still proceed.',
        noIncidentInfo: 'No incident information available.',
        missingIncidentInfo: 'Incident information missing. Please generate PDF first.',
        missingToken: 'Access token missing. Please generate PDF again.',
        confirmFailed: 'Failed to confirm PDF', confirmSubmitFailed: 'Failed to confirm submission. ',
        downloadFailed: 'Failed to download PDF: '
      }
    },

    incidentDetails: {
      title: 'Incident Details',
      subtitle: 'Provide detailed information about the incident',
      descriptionTitle: 'Incident Description',
      descriptionHint: 'Describe what happened in detail',
      descriptionPlaceholder: 'Describe the incident in detail... Include what happened, when it occurred, who was involved, and any other relevant information.',
      dateLabel: 'Incident Date', typeLabel: 'Incident Type(s)',
      otherPlaceholder: 'Please specify the incident type',
      backBtn: 'Back', nextBtn: 'Next', savingBtn: 'Saving...',
      smart: {
        title: 'Some helpful details appear to be missing',
        hint: 'Adding these helps us process your case faster. You can still continue if you do not have them.',
        continueAnyway: 'Continue anyway',
        missingImei: "The IMEI of the stolen phone (the 15-digit number, e.g. dial *#06#).",
        missingTheftDate: 'The date on which the phone was stolen.',
        missingSimReg: 'The date your SIM card was re-registered with the operator.',
        missingScamChannel: "How the scammer contacted you (WhatsApp, email, phone call, Facebook, etc.)."
      },
      errors: {
        descriptionRequired: 'Please describe the incident',
        descriptionMin: 'Description must be at least 20 characters',
        dateRequired: 'Please select the incident date',
        typeRequired: 'Please select at least one incident type',
        otherRequired: 'Please specify the incident type'
      }
    },

    pdfPreview: {
      title: 'PDF Preview', loadingPdf: 'Loading PDF...', generatingPreview: 'Generating Preview...',
      errorTitle: 'Failed to Load Preview', goBackBtn: 'Go Back',
      readyTitle: 'PDF Ready!', readyMessage: 'Your complaint PDF has been generated successfully.',
      summaryTitle: 'Report Summary:', summaryReporter: 'Reporter:', summaryType: 'Type:',
      summaryDate: 'Date:', summaryLocation: 'Location:',
      viewBtn: 'View PDF', downloadBtn: 'Download PDF', waitingMessage: 'Waiting for PDF...',
      cancelBtn: 'Cancel', confirmBtn: 'Confirm & Submit Report', submittingBtn: 'Submitting...'
    },

    recaptchaGate: {
      title: "Security", titleHighlight: "Verification",
      subtitle: "Please confirm you're human before proceeding.",
      instruction: "Confirm you're not a robot",
      instructionDesc: "Check the box below to continue to the form.",
      verifying: "Verifying your response...",
      verifyingDesc: "This only takes a moment. Please do not close this page.",
      success: "Verification successful",
      successDesc: "You've been confirmed as a human. Redirecting to the form...",
      redirecting: "Redirecting...", failed: "Verification failed",
      failedDesc: "We could not verify your identity. Please try again.",
      goBack: "Go Back", retry: "Try Again",
      protected: "This site is protected by reCAPTCHA and the Google",
      privacyPolicy: "Privacy Policy", and: "and", termsOfService: "Terms of Service", apply: "apply."
    },

    addressDocs: {
      title: 'Address & Identification', subtitle: 'Provide your residence details and ID documents',
      addressLabel: 'Residence Address', addressPlaceholder: '123 Main Street, Apartment 4B',
      characters: 'characters', townLabel: 'Town/City', townPlaceholder: 'Yaoundé',
      uploadDocLabel: 'Upload Document', idCardTitle: 'National ID Card', idCardHint: 'Upload front & back',
      passportTitle: 'Passport', passportHint: 'Upload biometric page',
      restoredBanner: 'Your ID documents have been restored from your previous session.',
      restoredBannerHint: 'You can continue without re-uploading, or upload new documents to replace them.',
      idFrontLabel: 'ID Card Front', idFrontHint: 'Max 5MB • JPG, PNG',
      idBackLabel: 'ID Card Back', idBackHint: 'Max 5MB • JPG, PNG',
      tapToUpload: 'Tap to upload', passportBioLabel: 'Passport Biometric Page',
      passportBioHint: 'Max 10MB • JPG, PNG, PDF', tapToUploadPdf: 'Tap to upload (JPG, PNG, PDF)',
      backBtn: 'Back', nextBtn: 'Next', uploadingBtn: 'Uploading...',
      errors: {
        addressRequired: 'Residence address is required', townRequired: 'Town/City is required',
        idFrontRequired: 'Please upload the front of your ID card',
        idBackRequired: 'Please upload the back of your ID card',
        passportRequired: 'Please upload your passport biometric page',
        fileTooLarge5: 'File size must be under 5 MB', fileTooLarge10: 'File size must be under 10 MB',
        imageOnly: 'Only JPG, PNG, and GIF images are allowed',
        imageOrPdfOnly: 'Only JPG, PNG, GIF images and PDF are allowed',
        processFailed: 'This photo could not be read. Please try another photo or a screenshot of it.',
        fixHighlighted: 'Please complete the highlighted fields and add both photos before continuing.',
        sessionNotFound: 'Session not found. Please refresh the page and try again.',
        uploadFailed: 'Upload failed. Please try again.'
      }
    },

    common: { previous: "Previous", next: "Next", errorLoading: "Failed to load data. Please try again later." },

    personalities: {
      title: "Public Personalities", subtitle: "Explore a directory of notable public figures and their official social media presence.",
      searchLabel: "Search Personalities", searchPlaceholder: "Search by name or title...",
      showLabel: "Show", perPage: "{count} per page", noSocials: "No social media links",
      noResultsTitle: "No Personalities Found", noResultsSubtitle: "Your search for \"{query}\" did not match any records."
    },

    search: {
      placeholder: "Search for an official, organization, number...",
      verifying: "Verifying...", searching: "Searching...", recentSearches: "Recent searches",
      popularSearches: "Popular Searches", searchHistory: "Search History",
      noResults: "No results found for \"{searchTerm}\"", resultsCount: "About {count} results for \"{term}\"",
      maliciousWarningTitle: "Warning: Potentially Malicious Resource",
      maliciousWarningBody: "The resource you searched for, <strong class=\"text-red-800 break-all\">\"{resourceName}\"</strong>, has been flagged.",
      maliciousWarningAdvice: "Please exercise extreme caution.", understandAndClose: "I Understand, Close This Warning",
      verifiedTitle: "Resource Verified",
      verifiedBody: "The resource you searched for, <strong class=\"text-green-800 break-all\">\"{resourceName}\"</strong>, has been verified.",
      verifiedAdvice: "You can use this resource with confidence.", continue: "Continue",
      verificationNeededTitle: "Verification Needed",
      verificationNeededBody: "We could not find any information for the search term: <strong class=\"text-yellow-800 break-all\">\"{searchTerm}\"</strong>.",
      verificationNeededAdvice: "This means we cannot certify whether this resource is authentic or fake.",
      understandAndBeCareful: "I Understand and Will Be Careful"
    },

    searchResults: {
      home: "Home", placeholder: "Search ministries, officials...", didYouMean: "Did you mean:",
      matchedPersonnel: "Matched Personnel", contactsAndSocial: "Contacts & Social Media",
      missionsOf: "Missions", moreMissions: "+ {count} more missions",
      regionalsOf: "Regional Delegations", moreRegionals: "+ {count} more regional delegations",
      personnelOf: "Key Personnels", morePersonnel: "+ {count} more personnel", andMore: "more",
      noResults: { title: "No results found", subtitle: "Your search for \"{searchTerm}\" did not match any entries." },
      pagination: { previous: "Previous", next: "Next" },
      sidebar: { noMap: "No map or photo available", getDirections: "Get Directions", quickLinks: { title: "Quick Links", govPortal: "Government Portal", gazette: "Official Gazette", assembly: "National Assembly" } },
      initial: { title: "Search for ministries or officials", subtitle: "Enter a name or keyword in the search bar above." },
      header: { showingResults: "Showing {total} results for {intentText} {entity}", noResults: "No results found for \"{searchTerm}\"", peopleMatching: "people matching", locationsFor: "locations for", contactsFor: "contacts for" }
    },

    dashboard: {
      noAccountFor: "No {platform} account",
      aria: { collapse: "Collapse sidebar", expand: "Expand sidebar" },
      contactCard: { title: "Contact {name}" },
      error: { title: "An Error Occurred", suggestion: "Please check your internet connection and try again.", retry: "Retry", invalidStructure: "No valid structure ID was provided.", fetchingData: "An error occurred while fetching the structure data." },
      bossView: { biography: "Biography", noContactForPlatform: "No {platform} account available" },
      embassiesAndConsulates: "Embassies & Consulates"
    },

    embassy: {
      cameroonEmbassiesAbroad: "Cameroon Embassies Abroad", foreignEmbassiesInCameroon: "Foreign Embassies in Cameroon",
      searchPlaceholder: "Search by country or embassy name...", noEmbassiesFoundTitle: "No Embassies Found",
      searchagain: "Reset the Search", viewdetails: "View details",
      subtitle: "Find diplomatic representations and contact information",
      noEmbassiesFoundMessage: "The embassy information is still being updated for this category.",
      embassyOf: "Embassy of {country}", ambassador: "Ambassador", services: "Services", biography: "Biography",
      connectAndFollow: "Connect and Follow", noServicesTitle: "Services Coming Soon",
      noServicesDescription: "We are currently compiling the list of services offered by this embassy.",
      noServicesNote: "Please check back soon for updates.",
      error: { invalidEmbassy: "No valid embassy was specified.", embassyNotFound: "The requested embassy could not be found.", fetchingData: "An error occurred while fetching the embassy details." }
    },

    howToReport: {
      title: "How to Report", titleHighlight: "an Incident",
      desc: "A simple four-step process to submit cybersecurity incidents securely and efficiently",
      step1Title: "Identify", step1Desc: "Recognize suspicious activity, security breaches or cybersecurity incidents",
      step2Title: "Document", step2Desc: "Collect all relevant information, logs, screenshots, receipts and evidence of the incident",
      step3Title: "Submit", step3Desc: "Complete the reporting form with all gathered information securely and submit",
      step4Title: "Track", step4Desc: "Track your incident report and receive updates on resolution progress",
      titleLine1: "How to Report", titleLine2: "an Incident",
      subtitle: "A simple four-step process to submit cybersecurity incidents securely and efficiently",
      steps: {
        identify: { title: "Identify", description: "Recognize suspicious activity, security breaches or cybersecurity incidents" },
        document: { title: "Document", description: "Collect all relevant information, logs, screenshots, receipts and evidence of the incident" },
        submit: { title: "Submit", description: "Complete the reporting form with all gathered information securely and submit" },
        track: { title: "Track", description: "Track your incident report and receive updates on resolution progress" }
      }
    },

    stats: {
      title: "Security", titleHighlight: "Analytics",
      received: "Received Incidents", monthActivity: "This month's activity",
      mitigated: "Mitigated", successRate: "Success rate",
      pending: "Pending", activeInvestigations: "Active investigations",
      stolenPhones: "Stolen Phones Tracked", thisQuarter: "This quarter",
      uptime: "System Uptime", availability: "24/7 availability",
      responseTime: "Response Time", oneMinute: "1 Minute"
    },

    statistics: {
      title: 'Security', titleHighlight: 'Analytics',
      receivedLabel: 'Received Incidents', receivedActivity: "This month's activity",
      mitigatedLabel: 'Mitigated', mitigatedActivity: 'Success rate',
      pendingLabel: 'Pending', pendingActivity: 'Active investigations', pendingBadge: 'In Progress',
      phonesLabel: 'Stolen Phones Tracked', phonesActivity: 'This quarter',
      uptime: 'System Uptime', availability: '24/7 availability',
      responseTime: 'Response Time', responseValue: '1 Minute'
    },

    footer: {
      brandSub: 'Cyber Incident Response Team',
      systemOperational: 'Report Cyber Incidents with Confidence',
      about: { title: 'Secure Platform', desc: 'Advanced cybersecurity incident management system with military-grade encryption and real-time threat monitoring for Cameroon.', encryptionLabel: 'Encryption Active' },
      resources: { title: 'Cyber Resources', antic: 'ANTIC Official', cirt: 'CIRT Portal', guidelines: 'Security Guidelines', threats: 'Threat Reports' },
      contact: { title: 'Emergency Contact', emailLabel: 'Secure Email', hotlineLabel: 'Hotline', locationLabel: 'HQ Location', locationValue: 'Chinese Embassy, Bastos\nYaounde, Cameroon' },
      copyright: 'ANTIC/CIRT Computer Incident Response Team. All rights secured.',
      privacy: 'Privacy Policy', terms: 'Terms of Service'
    },

    followUp: {
      trackTitle: 'Track Your Incident', trackSubtitle: 'Enter your reference ID to view case status',
      referenceId: 'Reference ID', invalidFormat: 'Invalid format', invalidFormatLong: 'Invalid reference ID format',
      notFound: 'Reference ID not found. Please check and try again.', invalidRequest: 'Invalid request',
      networkError: 'Network error. Please try again later.', unableVerify: 'Unable to verify reference ID',
      verifying: 'Verifying...', accessDashboard: 'Access Dashboard',
      otpSentWhatsappPrefix: 'A verification code has been sent via WhatsApp to', otpSentEmailPrefix: 'A verification code has been sent to your email', otpSentSuffix: '. Enter it below to continue.',
      otpLabel: 'Verification Code', otpPlaceholder: '6-digit code',
      verifyAndAccess: 'Verify & Access Dashboard', useDifferentId: 'Use a different reference ID',
      contactOnRecord: 'the contact on record', tooManyRequests: 'Too many requests. Please wait a few minutes.',
      tooManyAttempts: 'Too many attempts. Please wait a few minutes.', invalidCode: 'Invalid or expired verification code.',
      submitted: 'Submitted', resolved: 'Resolved', active: 'Active',
      incidentDetails: 'Incident Details', old: 'old', type: 'Type',
      incidentDate: 'Incident Date', assignedTo: 'Assigned To', category: 'Category',
      description: 'Description', noDescription: 'No description provided', notSpecified: 'Not specified',
      evidence: 'Evidence', addFile: 'Add File', selectFiles: 'Click to select files',
      fileHint: 'Images, PDFs, Documents — max 10MB each', addMore: 'Add more',
      upload: 'Upload', uploading: 'Uploading...', cancel: 'Cancel',
      uploadSuccess: 'file(s) uploaded.', uploadFailed: 'Upload failed. Please try again.',
      exceedsLimit: 'exceeds 10MB limit.', noEvidence: 'No evidence files yet',
      noEvidenceHint: 'Use "Add File" to upload supporting documents',
      previewUnavailable: 'Preview unavailable', download: 'Download', timeline: 'Timeline',
      received: 'Received', underReview: 'Under Review', formalization: 'Formalization', closed: 'Closed',
      receivedDesc: 'Report recorded and logged in system.',
      underReviewDesc: 'Being analyzed by the investigation team.',
      formalizationDesc: 'Evidence processing and documentation.', closedDesc: 'Investigation completed.',
      completed: 'Completed', inProgress: 'In Progress',
      lawEnforcement: 'Follow Up with Law Enforcement',
      lawDesc: 'Your incident has been forwarded to Law Enforcement. Use the document reference below to follow up.',
      docReference: 'Document Reference', downloadDocument: 'Download Document',
      investigationOngoing: 'Investigation still ongoing', docNotAvailable: 'Document reference not yet available',
      plaintiffForm: 'Complaint Form', plaintiffDesc: 'Your official complaint form submitted with this incident.',
      downloadForm: 'Download Complaint Form', formNotAvailable: 'Complaint form not yet available',
      needHelp: 'Need Help?', includeRef: 'Include reference ID in all communications',
      hotline: 'Hotline', whatsapp: 'WhatsApp', privacy: 'Privacy', terms: 'Terms', help: 'Help',
      copyright: '© 2024 ANTIC CIRT — Computer Incident Response Team',
      securityIncident: 'Security Incident'
    }
  },

  fr: {
    home: "Accueil",
    followup: "Suivre un ticket",
    privateSector: "Secteur Privé",
    publicSector: "Secteur Publique",
    noaccounts: "Pas de compte",
    about: "À propos de nous",
    readyToReport: "Prêt à signaler un incident ?",
    reportIncidentNow: "Signaler un Incident",
    trackExistingReport: "Suivre un Incident Existant",
    saerch: "Rechercher",
    contactUs: "Contactez-nous",
    emptysearchResults: "Aucun résultat trouvé.",
    reportIncident: "Signaler un Incident",
    addStructure: "Ajouter une Structure",
    language: "FR",
    officialAccounts: "Répertoire des Comptes Officiels",
    nationalAgency: "AGENCE NATIONALE DES TECHNOLOGIES DE L'INFORMATION ET DE LA COMMUNICATION",
    directory: "RÉPERTOIRE DES COMPTES OFFICIELS DES STRUCTURES PUBLIQUES ET PRIVÉES",
    head: "Chef de la structure",
    otherspersonnels: "Personnels clés",
    regionals: "Délégations Régionales",
    more: "en savoir plus",
    auth: "Plateforme de Signalement et de Suivi des Incidents Cybernétiques",
    fillFormBelow: "Remplissez le formulaire ci-dessous pour signaler toute usurpation d'identité.",
    name: "Noms Complets",
    enterName: "Veuillez saisir vos noms et prénoms ici",
    phone: "Numéro de téléphone",
    enterPhone: "Veuillez saisir votre numéro de téléphone",
    email: "Email",
    enterEmail: "Veuillez saisir un compte e-mail valide",
    description: "Description",
    evidences: "Preuves",
    maxFiles: "Les preuves ne doivent pas dépasser 5",
    browseFiles: "Parcourir les fichiers",
    dragDropFiles: "Glisser-déposer des fichiers",
    addMoreFiles: "Ajouter d'autres preuves",
    submit: "Soumettre",
    submitting: "Soumission",
    construct: "En maintenance",
    constructMessage: "Nous travaillons actuellement sur cette section. Veuillez revenir bientôt !",
    messageContact: "Envoyez-nous un Message",
    umsg: "Votre message",
    location: "Localisation",
    actuallocation: "Rue de l'Ambassade de Chine (Bastos)",
    townnation: "Yaoundé",
    follow: "Suivez-nous sur",
    instructform: "Remplissez le formulaire ou contactez-nous par nos autres canaux",
    contactinfo: "Contactez-Nous",
    emergency: "Urgence",
    intouch: "Laissez-nous un Message",
    intouchinfo: "Nous sommes là pour vous aider et répondre à toutes vos questions.",
    footerbanner: "Suivez-nous sur les réseaux sociaux :",
    apptitle: "CHECK-APP",
    appdes: "CHECK-APP est une solution visant à réduire le risque de cybercriminalité sur les réseaux sociaux",
    otherRrc: "AUTRES RESSOURCES",
    usefullinks: "LIENS UTILES",
    contacts: "CONTACTS",
    success: "Votre message a été envoyé avec succès. Notre équipe vous contactera bientôt !",
    nomissionsTtile: "Bientôt disponible",
    nomissiondescription: "Nous développons notre portefeuille de missions avec soin et précision.",
    nomissionnote: "Revenez bientôt pour des mises à jour.",
    noMissiondes: "Aucune description pour cette mission",
    missions: "Missions",
    popularMinistries: "Ministères Populaires",
    noPrivateSectorsAvailable: "Aucun secteur privé disponible pour le moment",
    fetchError: "Impossible de charger les données. Veuillez réessayer.",
    searchEmbassies: "Rechercher les Ambassades du Cameroun",
    loading: "chargement",
    embassies: "Missions Diplomatiques",
    noContactAvailable: "Pas de Compte",
    noResultsTitle: "Aucun titre pour ce résultat",
    noDescriptionAvailable: "Plus de détails bientôt !",
    noDataAvailable: "Aucune donnée disponible",
    noPhoneNumber: "Aucun numéro de téléphone",
    noLocation: "Aucune information de localisation",
    Main: "Contact Principal",
    getDirections: "Obtenir l'itinéraire Google Maps",
    noInformationAvailable: "Indisponible pour le moment",
    bossContactSection: "Connectez-vous et suivez",
    noLocationAvailable: "Aucune localisation disponible",
    readMore: "En savoir plus",
    clearHistory: "Effacer l'historique",
    noRegionalsTitle: "Aucune Délégation Régionale",
    noRegionalsDescription: "Les informations seront ajoutées bientôt.",
    searchPlaceholderShort: "Entrez un mot-clé",
    previous: "Précédent",
    next: "Suivant",
    embassiesAndConsulates: "Ambassades et Consulats",
    servicesOffered: "Services",
    "About CIRT": "À propos du CIRT",

    hero: {
      title1: "Plateforme de Signalement",
      title2: "d'Incidents Cybernétiques",
      subtitle: "Portail officiel pour le signalement sécurisé, le suivi et la gestion des incidents.",
      cardCyberTitle: "Signaler un Incident Cyber",
      cardCyberDesc: "Signalez la Compromision des Systemes, les Spams, le phishing et autres menaces cyber",
      cardCyberBtn: "Signaler",
      cardComplaintTitle: "Déposer une Plainte",
      cardComplaintDesc: "Soumettre un formulaire de plainte judiciaire officiel ANTIC",
      cardComplaintBtn: "Déposer",
      cardTrackTitle: "Suivre un Dossier",
      cardTrackDesc: "Suivez la progression de la résolution de votre incident",
      cardTrackBtn: "Suivre",
      cardIncidentsTitle: "Types d'Incidents Traités",
      cardIncidentsDesc: "Découvrez les types d'incidents que nous gérons",
      cardIncidentsBtn: "Voir les Types",
      titleLine1: "Incidents Cybernétiques", titleLine2: "Plateforme de Signalement",
      cards: {
        cyberIncident: { title: "Signaler un Incident Cyber", description: "Signaler un vol d'identité, une arnaque, un hameçonnage et d'autres incidents de cybersécurité", button: "Signaler" },
        complaint: { title: "Plainte Judiciaire", description: "Remplir et soumettre un formulaire de plainte ANTIC pour les délits cybernétiques", button: "Déposer une Plainte" },
        trackStatus: { title: "Suivi du Statut", description: "Suivre l'avancement de la résolution des incidents", button: "Suivre" },
        howToReport: { title: "Comment Signaler", description: "Apprendre le processus de signalement et de suivi", button: "Voir le Guide" }
      }
    },

    reportType: {
      title: "Signaler un", titleHighlight: "Incident",
      subtitle: "Choisissez le type de signalement qui correspond le mieux à votre situation.",
      chooseType: "Sélectionnez le Type de Signalement",
      chooseTypeDesc: "Chaque formulaire est conçu pour une catégorie spécifique d'incident.",
      cyberTitle: "Signaler un Incident de Cybersécurité",
      cyberDesc: "Pour la compromission de système, les spams, le phishing, et autres menaces cyber.",
      complaintTitle: "Formulaire de Plainte ANTIC",
      complaintDesc: "Formulaire officiel de plainte judiciaire pour les incidents nécessitant une action légale et une enquête formelle par l'ANTIC.",
      tagIdentityTheft: "Compromission de Système", tagScamming: "Spam", tagPhishing: "Phishing",
      tagJudicial: "Judiciaire", tagOfficial: "Formulaire Officiel",
      privacy: "Confidentialité", terms: "Conditions", help: "Aide"
    },

    reportSelection: {
      title: "Que souhaitez-vous signaler ?",
      subtitle: "Choisissez le type de rapport qui correspond le mieux à votre situation. Les deux formulaires sont sécurisés et confidentiels.",
      backToHome: "Retour à l'Accueil",
      cyberIncident: {
        title: "Signaler un Incident de Cybersécurité",
        description: "Utilisez ce formulaire pour signaler des incidents de cybersécurité tels que le vol d'identité, l'arnaque, l'hameçonnage, les violations de données ou toute fraude en ligne. Une pièce d'identité et des preuves sont requises.",
        cta: "Commencer le Signalement",
        tags: { identityTheft: "Vol d'Identité", scamming: "Arnaque", phishing: "Hameçonnage", hacking: "Piratage" }
      },
      anticComplaint: {
        title: "Remplir & Soumettre le Formulaire de Plainte ANTIC",
        description: "Complétez le formulaire officiel de plainte judiciaire ANTIC pour les cybercrimes incluant le piratage de comptes, l'usurpation d'identité, la défiguration web, le harcèlement cyber et les infections par logiciels malveillants.",
        cta: "Commencer le Formulaire de Plainte",
        tags: { webDefacement: "Défiguration Web", accountHijack: "Piratage de Compte", malware: "Logiciel Malveillant" }
      }
    },

    cyber: {
      searchCountry: 'Rechercher un pays...', noResults: 'Aucun résultat trouvé',
      formTitle: "Incident de", formTitleHighlight: "Cybersécurité",
      formSubtitle: "Déclarez votre incident de cybersécurité en toute sécurité. Toutes les informations sont chiffrées et confidentielles.",
      stepType: "Type", stepInfo: "Informations", stepDetails: "Détails", stepEvidence: "Preuves", stepDone: "Terminé",
      step0Title: "Type d'Incident", step0Desc: "Sélectionnez un ou plusieurs types d'incidents qui s'appliquent à votre situation.",
      step1Title: "Informations de Contact", step1Desc: "Fournissez vos informations d'identification personnelle. Ceci est requis pour traiter votre signalement.",
      step2Title: "Détails de l'Incident", step2Desc: "Décrivez l'incident avec autant de détails que possible.",
      step3Title: "Preuves à l'Appui", step3Desc: "Téléchargez des captures d'écran, documents ou tout fichier soutenant votre signalement.",
      typeIdentityTheft: "Vol d'Identité", typeIdentityTheftDesc: "Quelqu'un utilise votre identité sans autorisation",
      typeScamming: "Arnaque / Fraude", typeScammingDesc: "Fraude financière, fausses offres, arnaques de transfert d'argent",
      typePhishing: "Hameçonnage (Phishing)", typePhishingDesc: "Emails ou sites web trompeurs pour voler vos identifiants",
      typeAccountHijack: "Piratage de Compte", typeAccountHijackDesc: "Accès non autorisé à votre compte de réseau social ou email",
      typeCyberHarassment: "Cyberharcèlement", typeCyberHarassmentDesc: "Menaces en ligne, intimidation ou harcèlement",
      typeMalware: "Logiciel Malveillant / Rançongiciel", typeMalwareDesc: "Infection par un logiciel malveillant sur votre appareil",
      typeDataBreach: "Violation de Données", typeDataBreachDesc: "Accès non autorisé à des données personnelles ou organisationnelles",
      typeOther: "Autre", typeOtherDesc: "Tout autre incident de cybersécurité non listé ci-dessus",
      specifyOther: "Veuillez préciser le type d'incident...",
      fullName: "Nom Complet", fullNamePh: "Entrez votre nom complet",
      email: "Adresse Email", emailPh: "votre.email{'@'}exemple.com",
      phone: "Numéro de Téléphone", city: "Ville", cityPh: "ex: Yaoundé",
      address: "Adresse de Résidence", addressPh: "Entrez votre adresse",
      idSection: "Pièce d'Identité", idType: "Type de Document", selectIdType: "-- Sélectionnez le type --",
      cni: "Carte Nationale d'Identité (CNI)", passport: "Passeport", driverLicense: "Permis de Conduire", residencePermit: "Titre de Séjour",
      idNumber: "Numéro du Document", idNumberPh: "Entrez le numéro du document",
      idUpload: "Télécharger la Pièce d'Identité", idUploadHint: "Cliquez ou glissez votre pièce d'identité ici",
      remove: "Supprimer", incidentDate: "Date de l'Incident", incidentTime: "Heure (approximative)",
      platform: "Plateforme / Service Affecté", selectPlatform: "-- Sélectionnez la plateforme --",
      emailService: "Service Email", website: "Site Web", banking: "Banque / Finance", otherPlatform: "Autre",
      suspectInfo: "Informations sur le Suspect (si connues)", suspectInfoPh: "Numéro de téléphone, nom d'utilisateur, compte, URL...",
      financialLoss: "Perte Financière Estimée", financialLossPh: "Montant (le cas échéant)",
      description: "Description Détaillée de l'Incident",
      descriptionPh: "Décrivez ce qui s'est passé, quand, comment vous l'avez découvert, les actions prises...",
      dragDrop: "Cliquez ou glissez des fichiers ici",
      evidenceFormats: "Images, PDFs, documents, vidéos - Max 50 Mo au total, 15 fichiers",
      continue: "Continuer", back: "Retour", submitReport: "Soumettre le Signalement", submitting: "Soumission en cours...",
      successTitle: "Signalement Soumis avec Succès !",
      successDesc: "Votre signalement d'incident de cybersécurité a été reçu. Notre équipe l'examinera et vous contactera sous peu.",
      referenceLabel: "Numéro de Référence", referenceHint: "Conservez ce numéro pour suivre votre signalement",
      newReport: "Soumettre un Autre Signalement", backHome: "Retour à l'Accueil", securedBy: "Sécurisé par reCAPTCHA",
      errSelectType: "Veuillez sélectionner au moins un type d'incident.",
      errSpecifyOther: "Veuillez préciser le type d'incident.", errRequired: "Ce champ est obligatoire.",
      errValidEmail: "Veuillez entrer une adresse email valide.", errIdUpload: "Veuillez télécharger votre pièce d'identité.",
      errDescMin: "La description doit contenir au moins 20 caractères.", errFileSize: "Le fichier doit faire moins de 10 Mo.",
      errFileType: "Type de fichier invalide. Seuls JPG, PNG et PDF sont acceptés.",
      errEvidenceSize: "La taille totale des preuves ne peut pas dépasser 50 Mo.",
      errEvidenceCount: "Maximum 15 fichiers de preuves autorisés.",
      submitSuccess: "Signalement soumis avec succès !", submitError: "Une erreur s'est produite. Veuillez réessayer."
    },

    cyberForm: {
      otherNatureLabel: "Veuillez préciser la nature de l'incident",
      otherNaturePlaceholder: 'ex. : menace interne, échange de SIM...',
      headerText: "Vous pouvez utiliser ce formulaire pour déclarer des incidents cybernétiques survenus au sein de votre organisme.",
      contactSection: "Contact", organisation: "Organisme", fullName: "Nom et Prénom",
      telephone: "Téléphone", telephonePh: "Entrez votre numéro de téléphone", email: "Email",
      incidentSection: "Incident", incidentSubject: "Objet de l'incident", incidentNature: "Nature de l'incident",
      select: "Sélectionner", incidentDate: "Date de l'incident", affectedAssets: "Actifs touchés",
      detailedDescription: "Description détaillée de l'incident", send: "Envoyer", sending: "Envoi en cours...",
      sidebarTitle: "Comment contacter le CIRT-CM en cas d'incidents cybernétiques ?",
      viaEmail: "Via Email", viaPhone: "Via Téléphone", website: "Site web",
      natureIdentityTheft: "Vol d'identité", natureScamming: "Arnaque / Fraude",
      naturePhishing: "Hameçonnage (Phishing)", natureAccountHijack: "Piratage de compte",
      natureCyberHarassment: "Cyber-harcèlement", natureMalware: "Logiciel malveillant (Malware)",
      natureDataBreach: "Violation de données", natureWebDefacement: "Défiguration de site web",
      natureDos: "Déni de service (DoS/DDoS)", natureRansomware: "Rançongiciel (Ransomware)", natureOther: "Autre",
      errRequired: "Ce champ est obligatoire.", errValidEmail: "Veuillez entrer une adresse email valide.",
      errDescMin: "La description doit contenir au moins 10 caractères.",
      submitSuccess: "Signalement envoyé avec succès !", submitError: "Une erreur s'est produite. Veuillez réessayer.",
      successTitle: "Signalement Envoyé avec Succès !",
      successDesc: "Votre signalement d'incident cybernétique a été reçu. Notre équipe l'examinera et vous contactera sous peu.",
      referenceLabel: "Numéro de Référence", referenceHint: "Conservez ce numéro pour suivre votre signalement",
      newReport: "Soumettre un Autre Signalement", backHome: "Retour à l'Accueil", securedBy: "Sécurisé avec reCAPTCHA",
      pageTitle: "Signalement d'Incident Cybernétique",
      pageSubtitle: "Utilisez ce formulaire pour déclarer des incidents cybernétiques. Les champs marqués d'un * sont obligatoires.",
      sections: { contact: "Contact", incident: "Incident" },
      fields: {
        organisation: "Organisme", fullName: "Nom et Prénom", phone: "Téléphone", email: "Email",
        idCard: "Pièce d'Identité du Plaignant",
        idCardHint: "Téléchargez le recto et le verso de votre carte d'identité nationale ou passeport (JPG, PNG ou PDF, max 10Mo chacun)",
        idFront: "Recto", idBack: "Verso", clickOrDrag: "Cliquez ou glissez un fichier",
        incidentSubject: "Objet de l'incident", incidentNature: "Nature de l'incident",
        incidentDate: "Date de l'incident", affectedAssets: "Actifs touchés",
        detailedDescription: "Description détaillée de l'incident", evidence: "Preuves",
        evidenceHint: "Téléchargez des captures d'écran, documents ou toute preuve de l'incident (max 10 fichiers, 25Mo au total)",
        dragEvidence: "Cliquez ou glissez des fichiers pour télécharger des preuves",
        maxFileSize: "JPG, PNG, PDF, DOC, ZIP — Max 25Mo au total"
      },
      placeholders: { phone: "Numéro de téléphone", select: "Sélectionner" },
      natures: {
        identityTheft: "Vol d'Identité", scamming: "Arnaque / Fraude en Ligne", phishing: "Hameçonnage (Phishing)",
        ransomware: "Rançongiciel (Ransomware)", dataBreach: "Violation de Données", ddos: "Attaque DDoS",
        malware: "Infection par Logiciel Malveillant", socialEngineering: "Ingénierie Sociale",
        webDefacement: "Défiguration de Site Web", unauthorizedAccess: "Accès Non Autorisé",
        accountHijacking: "Piratage de Compte", cyberHarassment: "Harcèlement Cybernétique", other: "Autre"
      },
      validation: {
        required: "Ce champ est obligatoire", invalidEmail: "Veuillez saisir une adresse email valide",
        idRequired: "Le recto de la pièce d'identité est obligatoire",
        fileTooLarge: "La taille du fichier ne doit pas dépasser 10 Mo",
        invalidFileType: "Type de fichier invalide. Acceptés : JPG, PNG, PDF",
        totalSizeExceeded: "La taille totale des fichiers dépasse 25 Mo",
        maxFilesExceeded: "Maximum 10 fichiers autorisés"
      },
      buttons: { back: "Retour", submit: "Soumettre le Signalement", submitting: "Soumission en cours..." },
      recaptchaNotice: "Ce formulaire est protégé par reCAPTCHA. En soumettant, vous acceptez notre politique de confidentialité.",
      sidebar: { title: "ANTIC - CIRT", emailLabel: "Par Email", phoneLabel: "Par Téléphone", faxLabel: "Fax", note: "Pour les incidents urgents, veuillez nous contacter directement par téléphone. Notre équipe est disponible 24h/24 pour les menaces critiques de cybersécurité." },
      success: { title: "Signalement Soumis avec Succès !", message: "Votre signalement d'incident cybernétique a été reçu. Notre équipe l'examinera et vous contactera sous peu.", reference: "Numéro de Référence", newReport: "Soumettre un Autre Signalement" },
      errors: { server: "Erreur du serveur. Veuillez réessayer plus tard.", network: "Erreur réseau. Veuillez vérifier votre connexion internet.", generic: "Une erreur s'est produite. Veuillez réessayer." },
      footer: { copyright: "Centre de Réponse aux Incidents Informatique", privacy: "Confidentialité", terms: "Conditions", help: "Aide" },
      errRateLimit: "Trop de soumissions. Veuillez patienter et réessayer."
    },

    incidentForm: {
      title: "Signalement", titleHighlight: "d'Incident",
      subtitle: "Bienvenue sur le Portail de Signalement des Incidents du Cameroun.",
      chooseVerification: "Choisissez votre méthode de vérification",
      phoneVerification: "Vérification par Téléphone", phoneVerificationDesc: "Recevoir un OTP via WhatsApp uniquement",
      emailVerification: "Vérification par Email", emailVerificationDesc: "Recevoir un OTP par email",
      privacy: "Confidentialité", terms: "Conditions", help: "Aide",
      welcome: "Bienvenue sur le Portail de Signalement d'Incidents du Cameroun.",
      steps: { verify: "Vérifier", personal: "Personnel", documents: "Documents", incident: "Incident", evidence: "Preuves", preview: "Aperçu", complete: "Terminé" },
      crimes: { defacement: "Défiguration de site web", hijacking: "Piratage de compte", itheft: "Usurpation d'identité", cyberH: "Cyber Harcèlement", scamming: "Escroquerie / Fraude en ligne", malware: "Infection par logiciel malveillant", malicious: "Publication de contenu malveillant", Ptheft: "Vol de téléphone", blackmail: "Cyber Chantage", other: "Autre" },
      authSelection: {
        title: "Choisissez votre méthode de vérification",
        phone: { title: "Vérification par Téléphone", description: "Recevoir l'OTP via WhatsApp uniquement" },
        email: { title: "Vérification par Email", description: "Recevoir l'OTP par email" }
      },
      footer: { copyright: "ANTIC CIRT - Centre de Réponse aux Incidents Informatique", privacy: "Confidentialité", terms: "Conditions", help: "Aide" }
    },

    common: { previous: "Précédent", next: "Suivant", errorLoading: "Échec du chargement. Veuillez réessayer." },

    personalities: {
      title: "Personnalités Publiques", subtitle: "Explorez un répertoire de personnalités publiques et leur présence officielle.",
      searchLabel: "Rechercher des Personnalités", searchPlaceholder: "Rechercher par nom ou titre...",
      showLabel: "Afficher", perPage: "{count} par page", noSocials: "Aucun lien de réseau social",
      noResultsTitle: "Aucune Personnalité Trouvée", noResultsSubtitle: "Votre recherche pour \"{query}\" n'a retourné aucun résultat."
    },

    search: {
      placeholder: "Rechercher un officiel, une organisation, un numéro...",
      verifying: "Vérification...", searching: "Recherche...", recentSearches: "Recherches récentes",
      popularSearches: "Recherches populaires", searchHistory: "Historique de recherche",
      resultsCount: "Environ {count} résultats pour \"{term}\"", noResults: "Aucun résultat pour \"{searchTerm}\"",
      maliciousWarningTitle: "Avertissement : Ressource potentiellement malveillante",
      maliciousWarningBody: "La ressource <strong class=\"text-red-800 break-all\">\"{resourceName}\"</strong> a été signalée.",
      maliciousWarningAdvice: "Veuillez faire preuve de prudence.", understandAndClose: "Je comprends, fermer cet avertissement",
      verifiedTitle: "Ressource vérifiée",
      verifiedBody: "La ressource <strong class=\"text-green-800 break-all\">\"{resourceName}\"</strong> a été vérifiée.",
      verifiedAdvice: "Vous pouvez utiliser cette ressource en confiance.", continue: "Continuer",
      verificationNeededTitle: "Vérification nécessaire",
      verificationNeededBody: "Aucune information trouvée pour : <strong class=\"text-yellow-800 break-all\">\"{searchTerm}\"</strong>.",
      verificationNeededAdvice: "Soyez prudent avec les ressources non vérifiées.",
      understandAndBeCareful: "Je comprends et serai prudent"
    },

    searchResults: {
      home: "Accueil", placeholder: "Rechercher ministères, officiels...", didYouMean: "Vouliez-vous dire :",
      matchedPersonnel: "Personnel correspondant", contactsAndSocial: "Contacts et Réseaux Sociaux",
      missionsOf: "Missions", moreMissions: "+ {count} autres missions",
      regionalsOf: "Délégations Régionales", moreRegionals: "+ {count} autres délégations",
      personnelOf: "Personnel Clé", morePersonnel: "+ {count} autres personnels", andMore: "plus",
      noResults: { title: "Aucun résultat trouvé", subtitle: "Votre recherche pour \"{searchTerm}\" n'a retourné aucun résultat." },
      pagination: { previous: "Précédent", next: "Suivant" },
      sidebar: { noMap: "Aucune carte disponible", getDirections: "Obtenir l'itinéraire", quickLinks: { title: "Liens Rapides", govPortal: "Portail du Gouvernement", gazette: "Journal Officiel", assembly: "Assemblée Nationale" } },
      initial: { title: "Rechercher des ministères ou officiels", subtitle: "Entrez un nom ou mot-clé ci-dessus." },
      header: { showingResults: "Affichage de {total} résultats pour {intentText} {entity}", noResults: "Aucun résultat pour \"{searchTerm}\"", peopleMatching: "personnes correspondant à", locationsFor: "lieux pour", contactsFor: "contacts pour" }
    },

    dashboard: {
      noAccountFor: "Aucun compte {platform}",
      aria: { collapse: "Réduire le menu", expand: "Étendre le menu" },
      contactCard: { title: "Contacter" },
      error: { title: "Une erreur est survenue", suggestion: "Vérifiez votre connexion Internet et réessayez.", retry: "Réessayer", invalidStructure: "Aucun ID de structure valide fourni.", fetchingData: "Erreur lors de la récupération des données." },
      bossView: { biography: "Biographie", noContactForPlatform: "Aucun compte {platform} disponible" },
      embassiesAndConsulates: "Ambassades et Consulats"
    },

    contactInput: {
      title: "Vérification d'Identité",
      subtitle: 'Nous vous enverrons un code de vérification sécurisé',
      emailLabel: 'Adresse Email', emailBadge: 'Email',
      emailPlaceholder: "vous{'@'}exemple.com",
      emailHint: "Entrez l'adresse email où vous recevrez le code de vérification",
      whatsappDownUseEmail: "WhatsApp est temporairement indisponible. Veuillez saisir votre adresse email pour recevoir votre code de vérification par email.",
      phoneLabel: 'Numéro de Téléphone', phonePlaceholder: '6XX XXX XXX',
      phoneHint: 'Entrez votre numéro de téléphone pour recevoir le code de vérification via WhatsApp',
      backBtn: 'Retour', sendBtn: 'Envoyer le Code', sendingBtn: 'Envoi en cours...'
    },

    submissionProgress: {
      title: 'Traitement en Cours',
      message: 'Veuillez patienter pendant que nous traitons votre plainte...',
      complete: '{percent}% complété'
    },

    privacyBanner: {
      title: 'Avis de Confidentialité',
      intro: 'Nous protégeons vos données conformément à la',
      law: 'Loi Camerounaise sur la Protection des Données (2024)',
      introSuffix: 'et suivons les meilleures pratiques du secteur en matière de cybersécurité.',
      keyProtections: 'Protections clés :',
      bullet1: 'Conformité aux réglementations nationales sur la protection des données',
      bullet2: 'Chiffrement et mesures de sécurité conformes aux standards du secteur',
      bullet3: 'Données utilisées uniquement pour le signalement et le traitement des incidents',
      acknowledgement: 'En continuant, vous reconnaissez nos pratiques en matière de confidentialité.',
      acceptBtn: "J'ai Compris"
    },

    embassy: {
      cameroonEmbassiesAbroad: "Ambassades du Cameroun à l'Étranger",
      foreignEmbassiesInCameroon: "Ambassades Étrangères au Cameroun",
      searchPlaceholder: "Rechercher par pays ou nom...", noEmbassiesFoundTitle: "Aucune Ambassade Trouvée",
      searchagain: "Réinitialiser la Recherche", viewdetails: "Plus de détails",
      subtitle: "Trouver les Missions Diplomatiques",
      noEmbassiesFoundMessage: "Les informations sont en cours de mise à jour.",
      embassyOf: "Ambassade du {country}", ambassador: "Ambassadeur", services: "Services",
      biography: "Biographie", connectAndFollow: "Connectez-vous et suivez",
      noServicesTitle: "Services Bientôt Disponibles",
      noServicesDescription: "Nous compilons la liste des services offerts.", noServicesNote: "Revenez bientôt.",
      error: { invalidEmbassy: "Aucune ambassade valide spécifiée.", embassyNotFound: "L'ambassade demandée n'a pas été trouvée.", fetchingData: "Erreur lors de la récupération des détails." }
    },

    privacy: {
      title: "Avis de Confidentialité",
      body: "Nous protégeons vos données conformément à",
      law: "la Loi sur la Protection des Données du Cameroun (2024)",
      bodyEnd: "et suivons les meilleures pratiques de l'industrie en matière de cybersécurité.",
      keyProtections: "Protections clés :",
      protection1: "Conformité aux réglementations nationales sur la protection des données",
      protection2: "Mesures de chiffrement et de sécurité aux normes de l'industrie",
      protection3: "Données utilisées uniquement pour le signalement et la réponse aux incidents",
      consent: "En continuant, vous reconnaissez nos pratiques de confidentialité.",
      accept: "Je Comprends"
    },

    pdfPreview: {
      title: "Aperçu PDF", loadingPdf: "Chargement du PDF...", generatingPreview: "Génération de l'aperçu...",
      errorTitle: "Échec du chargement de l'aperçu", goBackBtn: "Retour",
      readyTitle: "PDF Prêt !", readyMessage: "Votre PDF de plainte a été généré avec succès.",
      summaryTitle: "Résumé du rapport :", summaryReporter: "Déclarant :", summaryType: "Type :",
      summaryDate: "Date :", summaryLocation: "Lieu :",
      viewBtn: "Voir le PDF", downloadBtn: "Télécharger le PDF", waitingMessage: "En attente du PDF...",
      cancelBtn: "Annuler", confirmBtn: "Confirmer et soumettre le rapport", submittingBtn: "Envoi en cours..."
    },

    recaptchaGate: {
      title: "Vérification", titleHighlight: "Sécurité",
      subtitle: "Veuillez confirmer que vous êtes humain avant de continuer.",
      instruction: "Confirmez que vous n'êtes pas un robot",
      instructionDesc: "Cochez la case ci-dessous pour accéder au formulaire.",
      verifying: "Vérification de votre réponse...",
      verifyingDesc: "Cela ne prend qu'un instant. Ne fermez pas cette page.",
      success: "Vérification réussie",
      successDesc: "Vous avez été confirmé comme humain. Redirection vers le formulaire...",
      redirecting: "Redirection...", failed: "Échec de la vérification",
      failedDesc: "Nous n'avons pas pu vérifier votre identité. Veuillez réessayer.",
      goBack: "Retour", retry: "Réessayer",
      protected: "Ce site est protégé par reCAPTCHA et la",
      privacyPolicy: "Politique de confidentialité", and: "et les",
      termsOfService: "Conditions d'utilisation", apply: "de Google s'appliquent."
    },

    addressDocs: {
      title: "Adresse & Identification", subtitle: "Fournissez vos coordonnées de résidence et vos documents d'identité",
      addressLabel: "Adresse de résidence", addressPlaceholder: "123 Rue Principale, Appartement 4B",
      characters: "caractères", townLabel: "Ville", townPlaceholder: "Yaoundé",
      uploadDocLabel: "Télécharger un document", idCardTitle: "Carte Nationale d'Identité", idCardHint: "Télécharger recto & verso",
      passportTitle: "Passeport", passportHint: "Télécharger la page biométrique",
      restoredBanner: "Vos documents d'identité ont été restaurés depuis votre session précédente.",
      restoredBannerHint: "Vous pouvez continuer sans télécharger à nouveau, ou télécharger de nouveaux documents pour les remplacer.",
      idFrontLabel: "Recto de la CNI", idFrontHint: "Max 5Mo • JPG, PNG",
      idBackLabel: "Verso de la CNI", idBackHint: "Max 5Mo • JPG, PNG",
      tapToUpload: "Appuyer pour télécharger", passportBioLabel: "Page biométrique du passeport",
      passportBioHint: "Max 10Mo • JPG, PNG, PDF", tapToUploadPdf: "Appuyer pour télécharger (JPG, PNG, PDF)",
      backBtn: "Retour", nextBtn: "Suivant", uploadingBtn: "Téléchargement...",
      errors: {
        addressRequired: "L'adresse de résidence est obligatoire", townRequired: "La ville est obligatoire",
        idFrontRequired: "Veuillez télécharger le recto de votre CNI",
        idBackRequired: "Veuillez télécharger le verso de votre CNI",
        passportRequired: "Veuillez télécharger la page biométrique de votre passeport",
        fileTooLarge5: "La taille du fichier doit être inférieure à 5 Mo",
        fileTooLarge10: "La taille du fichier doit être inférieure à 10 Mo",
        imageOnly: "Seules les images JPG, PNG et GIF sont autorisées",
        imageOrPdfOnly: "Seules les images JPG, PNG, GIF et les PDF sont autorisés",
        processFailed: "Cette photo n'a pas pu être lue. Veuillez essayer une autre photo ou une capture d'écran.",
        fixHighlighted: "Veuillez compléter les champs en surbrillance et ajouter les deux photos avant de continuer.",
        sessionNotFound: "Session introuvable. Veuillez actualiser la page et réessayer.",
        uploadFailed: "Échec du téléchargement. Veuillez réessayer."
      }
    },

    successPage: {
      title: "Plainte Soumis avec Succès !",
      subtitle: "Merci d'avoir signalé l'incident",
      description: "Votre Plainte a été reçu en toute sécurité et un numéro de référence lui a été attribué. Notre équipe de cybersécurité examinera votre soumission et vous contactera si des informations supplémentaires sont nécessaires.",
      downloadTitle: "Télécharger Votre Plainte", downloadHint: "Conservez une copie de votre plainte pour vos archives",
      downloadBtn: "Télécharger la Plainte PDF", downloadingBtn: "Téléchargement...",
      nextStepsTitle: "Prochaines Étapes",
      nextStep1: "Vous recevrez un email de confirmation et/ou un message WhatsApp avec votre numéro de référence",
      nextStep2: "Notre équipe répond généralement dans les 24 à 48 heures pour les incidents urgents",
      nextStep3: "Conservez votre numéro de référence pour toute correspondance future et le suivi de l'avancement",
      homeBtn: "Retour à l'Accueil", resetBtn: "Signaler un Autre Incident"
    },

    progressBar: { step: "Étape {current} sur {total}", complete: "{percent}% Complété" },

    personalInfo: {
      title: "Informations Personnelles", subtitle: "Veuillez remplir vos informations personnelles ci-dessous",
      nameLabel: "Nom Complet", namePlaceholder: "Jean Dupont",
      emailLabel: "Adresse Email", emailPlaceholder: "jean{'@'}exemple.com",
      phoneLabel: "Numéro de Téléphone", phonePlaceholder: "6XX XXX XXX",
      phoneLockedNote: "Il s'agit du numéro vérifié qui a reçu votre code ; il ne peut pas être modifié.",
      ownerPhoneLabel: "Téléphone du titulaire du dossier (facultatif)",
      ownerPhonePlaceholder: '+237 6XX XXX XXX',
      ownerPhoneHint: "Si vous signalez au nom d'une autre personne, saisissez ici le numéro de la victime.",
      professionLabel: "Profession", professionPlaceholder: "Ingénieur Logiciel",
      docTypeLabel: "Type de Document", docTypeSelect: "Sélectionner le type de document",
      docTypeNationalId: "Carte Nationale d'Identité", docTypePassport: "Passeport", docTypeResidence: "Titre de Séjour",
      idNumberLabel: "Numéro", idNumberDocument: "Document",
      idPlaceholderNationalId: "Entrez votre numéro de carte d'identité",
      idPlaceholderPassport: "Entrez votre numéro de passeport",
      idPlaceholderResidence: "Entrez votre numéro de titre de séjour",
      idPlaceholderDefault: "Entrez votre numéro de document",
      backBtn: "Retour", nextBtn: "Suivant", savingBtn: "Enregistrement...",
      errors: {
        nameRequired: "Le nom complet est obligatoire", nameMin: "Le nom doit contenir au moins 2 caractères",
        emailInvalid: "Veuillez saisir une adresse email valide", phoneRequired: "Le numéro de téléphone est obligatoire",
        phoneInvalid: "Veuillez saisir un numéro de téléphone valide", docTypeRequired: "Veuillez sélectionner un type de document",
        idNumberRequired: "Le numéro de document est obligatoire"
      }
    },

    otpVerification: {
      title: "Vérifiez Votre Identité",
      subtitleEmail: "Entrez le code de vérification à 6 chiffres envoyé à votre email {contact}",
      subtitlePhone: "Entrez le code de vérification à 6 chiffres envoyé à votre téléphone {contact}",
      codeExpires: "Le code expire dans {time}", codeLabel: "Code de Vérification",
      digitAria: "Chiffre {index} du code de vérification", resendIn: "Renvoyer le code dans {time}",
      resendBtn: "Vous n'avez pas reçu le code ? Renvoyer", resendingBtn: "Envoi en cours...",
      backBtn: "Retour", verifyBtn: "Vérifier & Continuer", verifyingBtn: "Vérification..."
    },

    evidenceUpload: {
      title: "Téléversement de Preuves & Révision",
      subtitle: "Téléversez les documents justificatifs et vérifiez votre plainte avant soumission",
      sectionTitle: "Téléverser des fichiers de preuves (Facultatif)",
      dropzone: "Glissez-déposez les fichiers ici ou", chooseFiles: "Choisir des fichiers",
      fileHint: "Max 10 fichiers, 25 Mo au total • Images, PDFs, Documents",
      filesSelected: "{count} fichier(s) sélectionné(s)", clearAll: "Tout effacer",
      backBtn: "Retour", previewBtn: "Aperçu de la plainte PDF", generatingBtn: "Génération du PDF...",
      cancelConfirm: "Êtes-vous sûr de vouloir annuler ? Toutes les modifications non sauvegardées seront perdues.",
      pdfReady: "✅ PDF prêt !", downloadStarted: "✅ Téléchargement du PDF démarré !",
      modal: {
        title: "Aperçu de la plainte", submittingTitle: "Soumission de la plainte...",
        submittingMessage: "Veuillez patienter pendant que nous traitons votre soumission.",
        step1: "Confirmation du PDF", step2: "Téléversement des preuves", step3: "Finalisation",
        loadingDoc: "Chargement du document...", errorTitle: "Impossible de charger l'aperçu",
        downloadInstead: "Télécharger le PDF à la place", downloadingBtn: "Téléchargement...",
        pdfReadyTitle: "PDF Prêt !", pdfReadyMessage: "Votre PDF de plainte a été généré avec succès.",
        summaryTitle: "Résumé du rapport :", summaryName: "Nom :", summaryType: "Type :",
        summaryDate: "Date :", summaryRef: "Référence :",
        viewPdfBtn: "Voir le PDF", downloadPdfBtn: "Télécharger le PDF",
        docGeneratedTitle: "Document Généré !", docGeneratedMessage: "Votre plainte est prête pour soumission.",
        cancelBtn: "Annuler", confirmBtn: "Confirmer et soumettre", submittingBtn: "Soumission en cours..."
      },
      errors: {
        maxFiles: "Maximum {max} fichiers autorisés", totalSize: "La taille totale des fichiers dépasse 25 Mo",
        sessionNotFound: "Session introuvable. Veuillez compléter les étapes précédentes.",
        generateFailed: "Échec de la génération du PDF.", missingIncidentId: "Erreur serveur : Identifiant d'incident manquant",
        previewUnavailable: "PDF généré mais aperçu indisponible. Vous pouvez toujours soumettre.",
        previewFailed: "Échec du chargement de l'aperçu PDF. Vous pouvez toujours soumettre.",
        error404: "Point d'accès de génération PDF introuvable. Veuillez contacter le support.",
        error500: "Erreur serveur lors de la génération du PDF. Veuillez réessayer.",
        timeout: "Délai de génération du PDF dépassé. Veuillez réessayer.",
        network: "Erreur de connexion réseau. Vérifiez votre connexion internet.",
        invalidPdf: "Le fichier PDF est trop petit ou invalide",
        missingIdOrToken: "Identifiant d'incident ou jeton d'accès manquant",
        iframeError: "L'aperçu PDF n'a pas pu être chargé. Vous pouvez toujours continuer.",
        noIncidentInfo: "Aucune information d'incident disponible.",
        missingIncidentInfo: "Informations d'incident manquantes. Veuillez générer le PDF d'abord.",
        missingToken: "Jeton d'accès manquant. Veuillez générer le PDF à nouveau.",
        confirmFailed: "Échec de la confirmation du PDF",
        confirmSubmitFailed: "Échec de la confirmation de soumission. ",
        downloadFailed: "Échec du téléchargement du PDF : "
      }
    },

    // French incidentDetails — clean single apostrophes, no escaping needed
    incidentDetails: {
      title: "Détails de l'Incident",
      subtitle: "Fournissez des informations détaillées sur l'incident",
      descriptionTitle: "Description de l'Incident",
      descriptionHint: "Décrivez ce qui s'est passé en détail",
      descriptionPlaceholder: "Décrivez l'incident en détail... Indiquez ce qui s'est passé, quand cela s'est produit, qui était impliqué, et toute autre information pertinente.",
      dateLabel: "Date de l'Incident",
      typeLabel: "Type(s) d'Incident",
      otherPlaceholder: "Veuillez préciser le type d'incident",
      backBtn: "Retour", nextBtn: "Suivant", savingBtn: "Enregistrement...",
      smart: {
        title: "Certaines informations utiles semblent manquantes",
        hint: "Ajouter ces informations nous aide à traiter votre dossier plus rapidement. Vous pouvez tout de même continuer si vous ne les avez pas.",
        continueAnyway: "Continuer quand même",
        missingImei: "L'IMEI du téléphone volé (le numéro à 15 chiffres, composez *#06#).",
        missingTheftDate: "La date à laquelle le téléphone a été volé.",
        missingSimReg: "La date de ré-enregistrement de votre carte SIM auprès de l'opérateur.",
        missingScamChannel: "Comment l'escroc vous a contacté (WhatsApp, email, appel téléphonique, Facebook, etc.)."
      },
      errors: {
        descriptionRequired: "Veuillez décrire l'incident",
        descriptionMin: "La description doit contenir au moins 20 caractères",
        dateRequired: "Veuillez sélectionner la date de l'incident",
        typeRequired: "Veuillez sélectionner au moins un type d'incident",
        otherRequired: "Veuillez préciser le type d'incident"
      }
    },

    objectives: {
      title: 'Fonctionnalités et', titleHighlight: 'Capacités',
      description: "Plateforme complète de gestion des incidents de cybersécurité basée sur les meilleures pratiques et cadres éprouvés de l'industrie",
      card1: { title: 'Signalement Efficace', badge: 'Principal', description: "Rationalisez les processus de signalement d'incidents avec des flux de travail intuitifs, une documentation automatisée et des formulaires standardisés conformes aux cadres de l'industrie. Vous pouvez désormais signaler les incidents rapidement et avec précision, où que vous soyez et à tout moment.", tag1: 'Auto-classification', tag2: 'Rapide et Fiable', tag3: 'Pas besoin de se déplacer' },
      card2: { title: 'Mises à Jour en Temps Réel', description: "Suivez l'état de vos plaintes et incidents en temps réel. Soyez informé immédiatement des mises à jour, changements ou résolutions.", badge: 'Surveillance Active' },
      card3: { title: 'Analyses Avancées', description: "Suivez vos plaintes et incidents avec des tableaux de bord complets et publiez des actions importantes si applicable. Vous pouvez compléter et mettre à jour vos incidents et plaintes depuis le tableau de bord." },
      card4: { title: "Quels types d'incidents sont traités?", description: "Il existe une large gamme d'incidents de cybersécurité et de précurseurs de sécurité que notre plateforme est conçue pour gérer, notamment : Vol ou Perte de Téléphone/Tablette, Comptes de Réseaux Sociaux Piratés, Compromission de Compte Email, Escroquerie, Tentatives d'Usurpation d'Identité, Défiguration de Site Web, Publication de Contenu Malveillant, Cyber-harcèlement, Infection par Malware, Attaques de la Chaîne d'Approvisionnement.", badge: 'Chiffrement AES 256 bits' },
      card5: { title: 'Confidentialité et Protection des Données', description: "Notre plateforme est construite avec un accent fort sur la confidentialité et la protection des données. Basé sur les meilleures pratiques, nous garantissons que toutes les données des utilisateurs et les détails des incidents sont stockés et transmis en toute sécurité à l'aide de protocoles de chiffrement avancés. L'Équipe de Réponse aux Incidents du Cameroun (CIRT) adhère à des politiques strictes de protection des données pour protéger les informations sensibles, conformément à la loi sur la protection des données personnelles au Cameroun." },
      card6: { title: 'Accessibilité Mondiale', description: "Accédez à la plateforme en toute sécurité depuis n'importe quel endroit dans le monde avec un support multilingue robuste et une disponibilité 24h/24 et 7j/7.", bullet1: 'Cette plateforme est principalement conçue pour répondre aux incidents au Cameroun', bullet2: "Si un incident dépasse notre territoire d'influence, des efforts coordonnés avec les organes internationaux sont déclenchés.", bullet3: "Support des principales langues dont l'anglais et le français" },
      titleLine1: "Fonctionnalités et", titleLine2: "Capacités",
      subtitle: "Plateforme complète de gestion des incidents de cybersécurité basée sur les meilleures pratiques et cadres éprouvés de l'industrie",
      cards: {
        reporting: { title: "Signalement Efficace", badge: "Principal", description: "Rationalisez les processus de signalement d'incidents avec des flux de travail intuitifs, une documentation automatisée et des formulaires normalisés conformes aux cadres de l'industrie. Vous pouvez maintenant signaler des incidents rapidement et précisément depuis n'importe où, à tout moment.", tag1: "Auto-classification", tag2: "Rapide et Fiable", tag3: "Sans déplacement" },
        realtime: { title: "Mises à Jour en Temps Réel", description: "Suivez l'état de vos plaintes et incidents en temps réel. Soyez informé immédiatement des mises à jour, changements ou résolutions.", badge: "Surveillance Active" },
        analytics: { title: "Analytique Avancée", description: "Suivez vos plaintes et incidents avec des tableaux de bord complets et publiez des actions significatives si applicable. Vous pouvez compléter et mettre à jour vos incidents depuis le tableau de bord." },
        incidentTypes: { title: "Quels types d'incidents sont traités ?", description: "Il existe une large gamme d'incidents de cybersécurité que notre plateforme est conçue pour traiter, notamment : Vol/Perte de Téléphone/Tablette, Comptes de Réseaux Sociaux Piratés, Compromission de Compte Email, Arnaque, Tentatives de Vol d'Identité, Défiguration Web, Publication de Contenu Malveillant, Harcèlement Cyber, Infection par Logiciel Malveillant, Attaques de la Chaîne d'Approvisionnement." },
        privacySecurity: { title: "Confidentialité et Sécurité", description: "Notre plateforme est construite avec un fort accent sur la confidentialité et la sécurité. Basé sur les meilleures pratiques, nous assurons que toutes les données utilisateur et les détails d'incidents sont stockés et transmis de manière sécurisée. L'Équipe de Réponse aux Incidents du Cameroun (CIRT) adhère à des politiques strictes de protection des données." },
        globalAccess: { title: "Accessibilité Mondiale", description: "Accédez à la plateforme de manière sécurisée depuis n'importe quel endroit dans le monde avec un support multilingue robuste et une disponibilité 24h/24.", point1: "Cette plateforme est principalement conçue pour répondre aux incidents au Cameroun", point2: "Si un incident dépasse notre territoire d'influence, des efforts coordonnés avec les organes internationaux sont déclenchés.", point3: "Support des langues principales dont l'anglais et le français" }
      }
    },

    howToReport: {
      title: "Comment Signaler", titleHighlight: "un Incident",
      desc: "Un processus simple en quatre étapes pour soumettre des incidents de cybersécurité",
      step1Title: "Identifier", step1Desc: "Reconnaître les activités suspectes, les failles de sécurité ou les incidents cybernétiques",
      step2Title: "Documenter", step2Desc: "Collecter toutes les informations pertinentes, captures d'écran, reçus et preuves",
      step3Title: "Soumettre", step3Desc: "Remplir le formulaire de signalement avec toutes les informations recueillies et soumettre",
      step4Title: "Suivre", step4Desc: "Suivre votre signalement et recevoir des mises à jour sur la progression",
      titleLine1: "Comment Signaler", titleLine2: "un Incident",
      subtitle: "Un processus simple en quatre étapes pour soumettre des incidents de cybersécurité de manière sécurisée et efficace",
      steps: {
        identify: { title: "Identifier", description: "Reconnaître les activités suspectes, les failles de sécurité ou les incidents de cybersécurité" },
        document: { title: "Documenter", description: "Collecter toutes les informations pertinentes, journaux, captures d'écran, reçus et preuves de l'incident" },
        submit: { title: "Soumettre", description: "Remplir le formulaire de signalement avec toutes les informations recueillies de manière sécurisée et soumettre" },
        track: { title: "Suivre", description: "Suivre votre signalement d'incident et recevoir des mises à jour sur l'avancement de la résolution" }
      }
    },

    stats: {
      title: "Analyses de", titleHighlight: "Sécurité",
      received: "Incidents Reçus", monthActivity: "Activité du mois",
      mitigated: "Résolus", successRate: "Taux de succès",
      pending: "En Attente", activeInvestigations: "Enquêtes actives",
      stolenPhones: "Téléphones Volés Pistés", thisQuarter: "Ce trimestre",
      uptime: "Disponibilité du Système", availability: "Disponible 24h/24",
      responseTime: "Temps de Réponse", oneMinute: "1 Minute"
    },

    statistics: {
      title: 'Analyses de', titleHighlight: 'Sécurité',
      receivedLabel: 'Incidents Reçus', receivedActivity: 'Activité de ce mois',
      mitigatedLabel: 'Résolus', mitigatedActivity: 'Taux de réussite',
      pendingLabel: 'En Attente', pendingActivity: 'Enquêtes en cours', pendingBadge: 'En Cours',
      phonesLabel: 'Téléphones Volés Suivis', phonesActivity: 'Ce trimestre',
      uptime: 'Disponibilité du Système', availability: 'Disponible 24h/24 7j/7',
      responseTime: 'Temps de Réponse', responseValue: '1 Minute'
    },

    footer: {
      brandSub: 'Centre de Réponse aux Incidents de Sécurité Informatique',
      systemOperational: 'Signaler des Incidents de Cybersécurité',
      about: { title: 'Plateforme Sécurisée', desc: 'Système avancé de gestion des incidents de cybersécurité avec chiffrement militaire et surveillance des menaces en temps réel pour le Cameroun.', encryptionLabel: 'Chiffrement Actif' },
      resources: { title: 'Ressources Cyber', antic: 'ANTIC Officiel', cirt: 'Portail CIRT', guidelines: 'Directives de Sécurité', threats: 'Rapports de Menaces' },
      contact: { title: "Contact d'Urgence", emailLabel: 'Email Sécurisé', hotlineLabel: "Ligne d'Urgence", locationLabel: 'Siège Social', locationValue: 'Ambassade de Chine, Bastos\nYaoundé, Cameroun' },
      copyright: 'Centre de Réponse Aux Incidents de Sécurité Informatique ANTIC/CIRT. Tous droits réservés.',
      privacy: 'Politique de Confidentialité', terms: "Conditions d'Utilisation"
    },

    followUp: {
      trackTitle: 'Suivre Votre Incident', trackSubtitle: 'Entrez votre identifiant de référence pour voir le statut',
      referenceId: 'Identifiant de Référence', invalidFormat: 'Format invalide',
      invalidFormatLong: "Format d'identifiant de référence invalide",
      notFound: 'Identifiant de référence non trouvé. Veuillez vérifier et réessayer.',
      invalidRequest: 'Requête invalide', networkError: 'Erreur réseau. Veuillez réessayer plus tard.',
      unableVerify: "Impossible de vérifier l'identifiant de référence",
      verifying: 'Vérification...', accessDashboard: 'Accéder au Tableau de Bord',
      otpSentWhatsappPrefix: 'Un code de vérification a été envoyé par WhatsApp au', otpSentEmailPrefix: 'Un code de vérification a été envoyé à votre adresse e-mail', otpSentSuffix: '. Saisissez-le ci-dessous pour continuer.',
      otpLabel: 'Code de vérification', otpPlaceholder: 'Code à 6 chiffres',
      verifyAndAccess: 'Vérifier et accéder au tableau de bord', useDifferentId: 'Utiliser un autre identifiant de référence',
      contactOnRecord: 'le contact enregistré', tooManyRequests: 'Trop de demandes. Veuillez patienter quelques minutes.',
      tooManyAttempts: 'Trop de tentatives. Veuillez patienter quelques minutes.', invalidCode: 'Code de vérification invalide ou expiré.',
      submitted: 'Soumis le', resolved: 'Résolu', active: 'Actif',
      incidentDetails: "Détails de l'Incident", old: 'ancienneté', type: 'Type',
      incidentDate: "Date de l'Incident", assignedTo: 'Assigné à', category: 'Catégorie',
      description: 'Description', noDescription: 'Aucune description fournie', notSpecified: 'Non spécifié',
      evidence: 'Preuves', addFile: 'Ajouter un Fichier', selectFiles: 'Cliquez pour sélectionner des fichiers',
      fileHint: 'Images, PDFs, Documents — max 10Mo chacun', addMore: 'Ajouter plus',
      upload: 'Téléverser', uploading: 'Téléversement...', cancel: 'Annuler',
      uploadSuccess: 'fichier(s) téléversé(s).', uploadFailed: 'Échec du téléversement. Veuillez réessayer.',
      exceedsLimit: 'dépasse la limite de 10Mo.', noEvidence: 'Aucune preuve disponible',
      noEvidenceHint: 'Utilisez "Ajouter un Fichier" pour téléverser des documents',
      previewUnavailable: 'Aperçu indisponible', download: 'Télécharger', timeline: 'Chronologie',
      received: 'Reçu', underReview: 'En Examen', formalization: 'Formalisation', closed: 'Clôturé',
      receivedDesc: 'Rapport enregistré et consigné dans le système.',
      underReviewDesc: "En cours d'analyse par l'équipe d'investigation.",
      formalizationDesc: 'Traitement des preuves et documentation.', closedDesc: 'Investigation terminée.',
      completed: 'Terminé', inProgress: 'En Cours',
      lawEnforcement: "Suivi auprès des Forces de l'Ordre",
      lawDesc: "Votre incident a été transmis aux Forces de l'Ordre. Utilisez la référence du document ci-dessous pour le suivi.",
      docReference: 'Référence du Document', downloadDocument: 'Télécharger le Document',
      investigationOngoing: 'Investigation en cours', docNotAvailable: 'Référence du document pas encore disponible',
      plaintiffForm: 'Formulaire de Plainte', plaintiffDesc: 'Votre formulaire de plainte officiel soumis avec cet incident.',
      downloadForm: 'Télécharger le Formulaire de Plainte', formNotAvailable: 'Formulaire de plainte pas encore disponible',
      needHelp: "Besoin d'Aide ?", includeRef: 'Incluez votre identifiant de référence dans toutes les communications',
      hotline: "Ligne d'Urgence", whatsapp: 'WhatsApp', privacy: 'Confidentialité', terms: 'Conditions', help: 'Aide',
      copyright: '© 2024 ANTIC CIRT — Équipe de Réponse aux Incidents Informatiques',
      securityIncident: 'Incident de Sécurité'
    }
  }
};

function getInitialLocale() {
  const savedLocale = localStorage.getItem('user-language');
  if (savedLocale && Object.keys(messages).includes(savedLocale)) return savedLocale;
  return 'en';
}

const i18n = createI18n({
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
  legacy: true,
  globalInjection: true,
  warnHtmlMessage: false,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
});

export default i18n;